import React, { useEffect, useState } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from '../hooks/useAuth';

const AuthGuard = ({ children }) => {
  const location = useLocation();
  const { isAuthenticated, saveToken } = useAuth();
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    var token = localStorage.getItem("accessToken")
    if (!token) {
      autoLogin();
    }
    else setLoaded(true)
  }, []);

  const autoLogin = async () => {
    const urlParams = new URLSearchParams(location.search);
    const secret_token = urlParams.get("token");
    if (secret_token) {
      await saveToken(secret_token)
      setLoaded(true)
    }
    else setLoaded(true)
  }

  if (!isAuthenticated && loaded) {
    return <Redirect to="/login" />;
  }

  return (
    loaded ?
      <>
        { children}
      </>
      : ''
  );
};

AuthGuard.propTypes = {
};

export default AuthGuard;
